import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { SupervisorDashboardPage } from '../modules/supervisor-dashboard/ui/pages/SupervisorDashboardPage';

export const Route = createFileRoute('/_authenticated/dashboard/supervisor/')({
  // v1: the Supervisor dashboard is supervisor-only end-to-end. The backend also
  // authorizes org_admin/super_admin, but the admin shell only resolves an active
  // location for the supervisor role, so an admin reaching this route by URL would
  // be stuck on the "select a location" state with no picker. Gate the route to
  // supervisor to avoid that dead end. Admin access is a follow-up (needs an
  // in-page location picker).
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    if (session.user.role !== 'supervisor') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: SupervisorDashboardPage,
  staticData: {
    breadcrumb: ['Operate', 'Supervisor Dashboard'],
  },
});
